import * as THREE from 'three'
import { xDaEstruturaNaAltura, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'

/** Para-brisa e vidro traseiro trapezoidais entre a cintura e o teto estreito. */
export function geometriaVidroTransversal(perfil: PerfilVeiculo, extremidade: 'frente' | 'traseira'): THREE.BufferGeometry {
  const coluna = extremidade === 'frente' ? perfil.colunaA : perfil.colunaC
  const posicoes: number[] = []
  const indices: number[] = []
  const divisoesLargura = 12
  const divisoesAltura = 4
  for (let linha = 0; linha <= divisoesAltura; linha++) {
    const t = linha / divisoesAltura
    const y = perfil.cinturaY + (perfil.tetoY - perfil.cinturaY) * t
    const meiaLargura = xDaEstruturaNaAltura(perfil, 1, y) + 0.04
    const zBorda = coluna.zBase + (coluna.zTopo - coluna.zBase) * t
    for (let colunaX = 0; colunaX <= divisoesLargura; colunaX++) {
      const u = colunaX / divisoesLargura * 2 - 1
      // Curvatura discreta no sentido horizontal, preservando as bordas nas colunas.
      const bojo = (extremidade === 'frente' ? 1 : -1) * 0.012 * (1 - u * u)
      posicoes.push(meiaLargura * u, y, zBorda + bojo)
      if (linha < divisoesAltura && colunaX < divisoesLargura) {
        const a = linha * (divisoesLargura + 1) + colunaX
        const b = a + divisoesLargura + 1
        indices.push(a, b, a + 1, a + 1, b, b + 1)
      }
    }
  }
  const geometria = new THREE.BufferGeometry()
  geometria.setAttribute('position', new THREE.Float32BufferAttribute(posicoes, 3))
  geometria.setIndex(indices)
  geometria.computeVertexNormals()
  return geometria
}
